import { Shift4GuideEN } from '@/core/components/help-and-support/quick-answers/shift4-guide/en'
import { Shift4GuideES } from '@/core/components/help-and-support/quick-answers/shift4-guide/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/shift4-guide/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <Shift4GuideEN />
    case 'es':
      return <Shift4GuideES />
  }
}
